"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectRechargedCompanyVendorsByVendor = exports.selectUniqueAssignees = exports.makeSelectUserCan = exports.selectUnreadNotificationsCount = exports.selectNotificationGroups = exports.selectServiceStatsTeamData = exports.selectUniqueDepartments = void 0;
var end2end_1 = require("@hudled/end2end");
var date_fns_1 = require("date-fns");
var flatten_1 = __importDefault(require("lodash/fp/flatten"));
var flow_1 = __importDefault(require("lodash/fp/flow"));
var groupBy_1 = __importDefault(require("lodash/fp/groupBy"));
var map_1 = __importDefault(require("lodash/fp/map"));
var reverse_1 = __importDefault(require("lodash/fp/reverse"));
var sortBy_1 = __importDefault(require("lodash/fp/sortBy"));
var reselect_1 = require("reselect");
var ordered_1 = require("./ordered");
var populated_1 = require("./populated");
var populatedDerived_1 = require("./populatedDerived");
var single_1 = require("./single");
var utils_1 = require("./utils");
exports.selectUniqueDepartments = (0, reselect_1.createSelector)(populatedDerived_1.selectPopulatedServiceStats, function (serviceStats) {
    var _a;
    if (!((_a = serviceStats === null || serviceStats === void 0 ? void 0 : serviceStats[0]) === null || _a === void 0 ? void 0 : _a.service)) {
        return null;
    }
    var departments = serviceStats
        .map(function (serviceStat) { var _a; return (serviceStat.department || ((_a = serviceStat.service) === null || _a === void 0 ? void 0 : _a.department)); })
        .filter(Boolean);
    var uniqueDepartments = Array.from(new Set(departments));
    uniqueDepartments.sort();
    return uniqueDepartments;
});
exports.selectServiceStatsTeamData = (0, reselect_1.createSelector)(populatedDerived_1.selectPopulatedServiceStats, function (popSStats) { return popSStats && popSStats.reduce(function (tSStatsData, sS) {
    var _a;
    var tSSData = __assign({}, tSStatsData);
    if (!((_a = sS.companyTeams) === null || _a === void 0 ? void 0 : _a.length)) {
        tSSData.noTeamSStats = __spreadArray(__spreadArray([], __read(tSSData.noTeamSStats), false), [sS], false);
        return tSSData;
    }
    sS.companyTeams.forEach(function (t) {
        tSSData.teamSStats[t.id] = !tSSData.teamSStats[t.id] ? [sS] : __spreadArray(__spreadArray([], __read(tSSData.teamSStats[t.id]), false), [sS], false);
        tSSData.totalHeadcounts[sS.id] = (tSSData.totalHeadcounts[sS.id] || 0) + (t.headcount || 0);
    });
    return tSSData;
}, { noTeamSStats: [], teamSStats: {}, totalHeadcounts: {} }); });
var NON_GROUPED_NOTIF_TYPES = ['NEW_SERVICE', 'COMMENT_MENTION', 'COMMENT_ADDED', 'RENEWAL_UPCOMING',
    'CONNECTION_ACTIVATED', 'CONNECTION_DEACTIVATED', 'INSIGHT_AVAILABLE', 'RECH_ARCHIVED_CONTACT'];
// @types/lodash is wrong?
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
exports.selectNotificationGroups = (0, reselect_1.createSelector)(populated_1.selectOrderedPopulatedNotifications, function (orderedPopulatedNotifications) { return orderedPopulatedNotifications && (0, flow_1.default)((0, groupBy_1.default)('type'), 
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
map_1.default.convert({ cap: false })(function (group, type) { return NON_GROUPED_NOTIF_TYPES.includes(type)
    ? group.map(function (newToolNotifMeta) { return ({ type: type, group: [newToolNotifMeta] }); })
    : ({ type: type, group: group }); }), flatten_1.default, (0, sortBy_1.default)('group[0].updatedAt'), reverse_1.default)(orderedPopulatedNotifications); });
var getLatestUpdatedAt = function (notifGroup) { return (0, date_fns_1.max)(notifGroup.group.map(function (n) { var _a; return (_a = n.updatedAt) === null || _a === void 0 ? void 0 : _a.toDate(); }).filter(end2end_1.notFalsy)); };
exports.selectUnreadNotificationsCount = (0, reselect_1.createSelector)(exports.selectNotificationGroups, single_1.selectProfile, function (notifGroups, profile) {
    var _a;
    if (!(profile === null || profile === void 0 ? void 0 : profile.companyId) || !notifGroups) {
        return 0;
    }
    var lastReadOn = (_a = profile.notificationsLastReadOnPerCompany) === null || _a === void 0 ? void 0 : _a[profile.companyId];
    return notifGroups.filter(function (nG) { return !lastReadOn || getLatestUpdatedAt(nG) > (lastReadOn === null || lastReadOn === void 0 ? void 0 : lastReadOn.toDate()); }).length;
});
var selectUserCanCache = {};
var makeSelectUserCan = function (accessLevel) {
    if (accessLevel in selectUserCanCache)
        return selectUserCanCache[accessLevel];
    var selectUserCan = (0, reselect_1.createSelector)(single_1.selectProfile, function (profile) { return (0, end2end_1.userCan)(accessLevel)(profile); });
    selectUserCanCache[accessLevel] = selectUserCan;
    return selectUserCan;
};
exports.makeSelectUserCan = makeSelectUserCan;
exports.selectUniqueAssignees = (0, reselect_1.createSelector)(populated_1.selectPopulatedRecommendationsArray, single_1.selectAuth, utils_1.selectFirestore, function (recommendations, auth, _a) {
    var usersData = _a.data.users;
    if (!recommendations)
        return null;
    if (!usersData)
        return usersData;
    var assigneeIds = Array.from(new Set(__spreadArray(__spreadArray([], __read(recommendations
        .map(function (recommendation) { return (recommendation.assigneeId || recommendation.defaultAssigneeId); })
        .filter(Boolean)), false), [
        auth.uid,
    ], false)));
    return assigneeIds
        .filter(function (id) { return id && id in usersData && usersData[id]; })
        .map(function (id) { return (__assign({ id: id }, usersData[id])); });
});
exports.selectRechargedCompanyVendorsByVendor = (0, reselect_1.createSelector)(ordered_1.selectRechargedCompanyVendors, function (rechCompanyVendors) { return rechCompanyVendors && Object.fromEntries(rechCompanyVendors.map(function (rCV) { return [rCV.rechVendorId, rCV]; })); });
